import { render, staticRenderFns } from "./VerificationUndo.vue?vue&type=template&id=21594855&scoped=true&"
import script from "./VerificationUndo.vue?vue&type=script&lang=js&"
export * from "./VerificationUndo.vue?vue&type=script&lang=js&"
import style0 from "./VerificationUndo.vue?vue&type=style&index=0&id=21594855&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21594855",
  null
  
)

export default component.exports